<template>
  <b-container class="search-area" fluid="lg">
    <div class="mb-3">
      <b-form-row class="mb-4">
        <b-col>
          <h3 class="common__search-title">Tutor</h3>
          <input type="text" v-model="conditions.tutorNameOrId">
        </b-col>
        <b-col>
          <h3 class="common__search-title">YearMonth</h3>
          <YearMonthInput v-model="conditions.yearMonth" />
        </b-col>
        <b-col>
          <h3 class="common__search-title">Confirmed</h3>
          <ConfirmedInput v-model="conditions.confirmed" />
        </b-col>
      </b-form-row>
      <b-form-row class="mb-4">
        <b-col>
          <h3 class="common__search-title">Position</h3>
          <PositionsInput v-model="conditions.positions" />
        </b-col>
      </b-form-row>
    </div>
    <div class="d-flex justify-content-end">
      <b-button
        pill
        variant="secondary"
        @click="removeCondition"
        class="mr-2"
      >
        Reset
      </b-button>
      <b-button
        pill
        variant="primary"
        @click="search"
      >
        Search
      </b-button>
    </div>
  </b-container>
</template>

<script lang="ts">
import Vue from 'vue'
import _ from 'lodash';
import moment from 'moment'
import PositionsInput from '@/components/parts/inputItem/PositionsInput.vue';
import ConfirmedInput from '@/components/parts/inputItem/ConfirmedInput.vue';
import YearMonthInput from '@/components/parts/inputItem/YearMonthInput.vue';
import { TimesheetConditions } from '@/store/timesheets/types'

const timesheetConditions: TimesheetConditions = {
  yearMonth: moment().startOf('month'),
  positions: [],
  tutorNameOrId: '',
  confirmed: [true, false],
}

export default Vue.extend({
  data() {
    return {
      conditions: _.cloneDeep(timesheetConditions),
    };
  },

  components: {
    PositionsInput,
    ConfirmedInput,
    YearMonthInput,
  },

  methods: {
    /**
     * 検索ボタンクリック
     */
    search() {
      this.$emit('search', this.conditions);
    },
    /**
     * リセットボタンクリック
     */
    removeCondition() {
      this.conditions = _.cloneDeep(timesheetConditions);
      this.search();
    },
  },
})
</script>

<style scoped>
input[type="text"], select{
  padding: 5px;
  border: 1px solid #AAAFB6;
  border-radius: 30px;
  width: 200px;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
